import SG1FairTradingNotificationForm from "./bucket-1/sg1-fair-trading-notification-form";
import SG3MonthlyChecklistLicenseeForm from "./bucket-1/sg3-monthly-checklist-licensee-form";
import SG3YearlyChecklistLicenseeForm from "./bucket-1/sg3-yearly-checklist-licensee-form";
import SG9GiftsAndBenefitsRegister from "./bucket-1/sg9-gifts-and-benefits-register";
import SG10ReviewOfOperatingProcedure from "./bucket-1/sg10-review-of-operating-procedure";
import HalfYearlyFilesReviewForm from "./bucket-1/half-yearly-files-review-form.js";
import SG7ComplaintForm from "./bucket-2/sg7-complaint-form";
import SG7ComplaintFormRegister from "./bucket-1/sg7-complaint-form-register";
import SG2PolicyAndProcedureForm from "./bucket-2/sg2-policy-and-procedure-manual";
import SG3DailyBankingChecklist from "./bucket-2/sg3-daily-banking-checklist";
import SG3MonthlyChecklistForm from "./bucket-2/sg3-monthly-checklist-form";

export const formInfo = [
    {
        formType: "SG1FairTradingNotificationForm",
        formTitle: "SG 1 - Fair Trading Notification Form",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg1-fair-trading-notification-form",
        component: SG1FairTradingNotificationForm,
    },
    {
        formType: "SG2PolicyAndProcedureForm",
        formTitle: "SG 2 - Policy and Procedure Form",
        description: "Lorem Ipsum",
        bucket : "bucket_2",
        path: "/bucket-2/sg2-policy-and-procedure-manual-form",
        component: SG2PolicyAndProcedureForm ,
    },
    {
        formType: "SG3DailyBankingChecklist",
        formTitle: "SG 3 - Daily Banking Checklist",
        description: "Lorem Ipsum",
        bucket : "bucket_2",
        path: "/bucket-2/sg3-daily-banking-checklist",
        component: SG3DailyBankingChecklist,
    },
    {
        formType: "SG3MonthlyChecklistForm",
        formTitle: "SG 3.1 - Monthly Checklist Form",
        description: "Lorem Ipsum",
        bucket : "bucket_2",
        path: "/bucket-2/sg3-monthly-checklist-form",
        component: SG3MonthlyChecklistForm,
    },
    {
        formType: "SG3MonthlyChecklistLicenseeForm",
        formTitle: "SG 3.2 - Monthly Checklist Licensee Form",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg3-monthly-checklist-licensee-form",
        component: SG3MonthlyChecklistLicenseeForm,
    },
    {
        formType: "SG3YearlyChecklistLicenseeForm",
        formTitle: "SG 3.3 - Yearly Checklist Licensee Form",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg3-yearly-checklist-licensee-form",
        component: SG3YearlyChecklistLicenseeForm,
    },
    {
        formType: "SG7ComplaintFormRegister",
        formTitle: "SG 7 - Complaint Form Register",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg7-complaint-form-register",
        component: SG7ComplaintFormRegister ,
    },
    {
        formType: "SG7ComplaintForm",
        formTitle: "SG 7 - Complaint Form",
        description: "Lorem Ipsum",
        bucket : "bucket_2",
        path: "/bucket-2/sg7-complaint-form",
        component: SG7ComplaintForm ,
    },
    {
        formType: "SG9GiftsAndBenefitsRegister",
        formTitle: "SG 9 - Gifts and Benefits Register",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg9-gifts-benefits-register",
        component: SG9GiftsAndBenefitsRegister,
    },
    {
        formType: "SG10ReviewOfOperatingProcedure",
        formTitle: "SG 10 - Review of Operating Procedure",
        description: "Lorem Ipsum",
        bucket : "bucket_1",
        path: "/bucket-1/sg10-review-of-operating-procedure",
        component: SG10ReviewOfOperatingProcedure,
    },
    {
        formType : "HalfYearlyFilesReviewForm",
        formTitle : "Half Yearly Files Review Form",
        description : "Lorem Ipsum",
        bucket : "bucket_1",
        path : "/bucket-1/half-yearly-files-review-form",
        component : HalfYearlyFilesReviewForm
    }
];
